import React, { useState } from "react";
import { Typography, Chip, Avatar } from "@mui/material";
import CustomTable from "../../../components/Table/Table";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useAllRolesCategoryViewModel } from "./AllRolesCategoryViewModel";
// import AddClient from "../AddClient/AddClient";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import { StyledCardContent } from "./AllRolesCategoryStyles";
import { useLoading } from "../../../contexts/LoadingContext";
import Modal from "../../../components/Modal/Modal";
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import BusinessIcon from "@mui/icons-material/Business";
import CircleIcon from "@mui/icons-material/Circle";
import FactoryIcon from "@mui/icons-material/Factory";
import PublicIcon from "@mui/icons-material/Public";
import AddRoleCategory from "../manageRoleCategory/AddRoleCategory";
import { useRbac } from "../../../hooks/RbacContext";

const AllRolesCategory = () => {
  const {
    rolesCategory,
    loading,
    error,
    handleDelete,
    createRoleCategory,
    updateRoleCategory,
    refetch,
    handleSearch,
  } = useAllRolesCategoryViewModel();

  const { showLoading, hideLoading } = useLoading();

  const [isAddRoleOpen, setIsAddRoleOpen] = useState(false);
  const [selectedRole, setSelectedRole] = useState(null);
  const [successModal, setSuccessModal] = useState(null);
  const [deleteConfirmation, setDeleteConfirmation] = useState(null);
  const { checkAccess } = useRbac();
  const columns = [
    {
      id: "role_cat_name",
      label: "Name",
    },
    {
      id: "created_on",
      label: "Created On",
      align: "left",
      render: (value) => {
        if (!value) return '-';
        const [day, month, year] = value.split('/');
        const date = new Date(year, month - 1, day);
        return date.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric"
        });
      }
    },
    {
      id: "updated_on",
      label: "Updated On",
      align: "left",
      render: (value) => {
        if (!value) return '-';
        const [day, month, year] = value.split('/');
        const date = new Date(year, month - 1, day);
        return date.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric"
        });
      }
    },

    // {
    //   id: "is_active",
    //   label: "Status",
    //   align: "left",
    //   render: (value) => (
    //     <Chip
    //       label={value ? "Active" : "Inactive"}
    //       size="small"
    //       sx={{
    //         height: 24,
    //         fontSize: "0.75rem",
    //         fontWeight: 500,
    //         backgroundColor: value ? "#E8F5E9" : "#FFF3E0",
    //         color: value ? "#2E7D32" : "#EF6C00",
    //         "& .MuiChip-label": {
    //           px: 1.5,
    //         },
    //       }}
    //     />
    //   ),
    //   searchValue: (value) => (value ? "active" : "inactive"),
    // },
  ];
  const fixedColumns = {
    left: [],
    right: ["is_active", "actions"],
  };
  const handleAddClient = () => {
    setSelectedRole(null);
    setIsAddRoleOpen(true);
  };

  const handleEditClient = (client) => {
    setSelectedRole(client);
    setIsAddRoleOpen(true);
  };

  const handleCloseDialog = () => {
    setIsAddRoleOpen(false);
    setSelectedRole(null);
  };

  const handleSubmit = async (formData) => {
    console.log("selectedRole", selectedRole)
    try {
      showLoading();
      if (selectedRole) {
        await updateRoleCategory(selectedRole.role_category_id, formData);
        setSuccessModal({
          type: "success",
          title: "Success",
          message: "Role Category updated successfully",
        });
      } else {
        await createRoleCategory(formData);
        setSuccessModal({
          type: "success",
          title: "Success",
          message: "Role Category added successfully",
        });
      }
      handleCloseDialog();
      await refetch();
    } catch (error) {
      throw error;
    } finally {
      hideLoading();
    }
  };

  const handleCloseSuccessModal = () => {
    setSuccessModal(null);
  };

  const handleDeleteClick = (roleCategory) => {
    console.log("130", roleCategory)
    setDeleteConfirmation({
      roleCategory,
      open: true,
    });
  };

  const handleDeleteConfirm = async () => {
    const roleCategory = deleteConfirmation.roleCategory;
    try {
      showLoading();
      await handleDelete(roleCategory);
      setDeleteConfirmation(null);
      setSuccessModal({
        type: "success",
        title: "Success",
        message: "Role Category deleted successfully",
      });
    } catch (error) {
      setSuccessModal({
        type: "error",
        title: "Action Failed",
        message: error.message || "Failed to delete role category",
      });
    } finally {
      hideLoading();
    }
  };

  const getActions = (client) => {
    const baseActions = [];
    if (checkAccess("roleCategory", "update")) {
      baseActions.push(
        {
          icon: <EditIcon fontSize="small" />,
          label: "Edit",
          onClick: handleEditClient,
          color: "primary",
          sx: {
            "&:hover": {
              backgroundColor: (theme) =>
                theme.palette.primary.lighter || "rgba(33, 150, 243, 0.08)",
            },
          },
        })
    }
    if (checkAccess("roleCategory", "delete")) {
      baseActions.push(
        {
          icon: <DeleteIcon fontSize="small" />,
          label: "Delete",
          onClick: handleDeleteClick,
          color: "error",
          sx: {
            "&:hover": {
              backgroundColor: (theme) =>
                theme.palette.error.lighter || "rgba(211, 47, 47, 0.08)",
            },
          },
        }
      )};

      return baseActions;
    };

    if (error) {
      return (
        <StyledCardContent>
          <Typography color="error">Error: {error}</Typography>
        </StyledCardContent>
      );
    }
    const columnFilters = [
      // {
      //   id: "is_active",
      //   type: "select",
      //   label: "Status",
      //   render: (value) => (value ? "Active" : "Inactive"),
      //   icon: <CircleIcon />,
      //   sendIcon: true,
      // },
    ];

    return (
      <div>
        <CustomTable
          columns={columns}
          data={rolesCategory}
          onAdd={handleAddClient}
          showActions={true}
          showAddButton={checkAccess("roleCategory", "add")}
          addButtonIcon={<PersonAddIcon />}
          showSearch={true}
          showColumnVisibility={false}
          pageSize={10}
          stickyHeader={true}
          fixedColumns={fixedColumns}
          actions={getActions}
          title="All Roles Category"
          subtitle="Manage and monitor all roles category"
          addButtonText="Add Roles Category"
          alignment="left"
          fontSize="12px"
          showFilters={true}
          columnFilters={columnFilters}
        />

        <AddRoleCategory
          open={isAddRoleOpen}
          onClose={handleCloseDialog}
          initialData={selectedRole}
          onSubmit={handleSubmit}
        />

        {successModal && (
          <Modal
            type={successModal.type}
            title={successModal.title}
            message={successModal.message}
            onClose={handleCloseSuccessModal}
          />
        )}

        {deleteConfirmation && (
          <ConfirmationModal
            open={true}
            title="Delete Role Category"
            message={`Are you sure you want to delete role category "${deleteConfirmation.roleCategory.role_cat_name}"?`}
            onClose={() => setDeleteConfirmation(null)}
            onConfirm={handleDeleteConfirm}
          />
        )}
      </div>
    );
  };

  export default AllRolesCategory;
